import firebaseInstance from "../../../util/firebase";
import firebase from "firebase";
import router from "../../../router";
import axios from "axios";

export default {
  createNewProject(state, item) {
    console.log("create new project action", item);
    var projectKey = "";
    var chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (var i = 32; i > 0; --i)
      projectKey += chars[Math.floor(Math.random() * chars.length)];
    var date = new Date();
    date = date.getTime();

    var projectData = {
      name: item.name,
      created: date,
      status: "pending",
      type: "website",
      users: {
        [item.myID]: "admin"
      }
    };

    var projectDataFull = {
      approach: "bottom-up",
      blendedRate: item.rate || 0,
      rate: item.rate || 0,
      contingency: item.contingency || 0,
      users: {
        [item.myID]: "admin"
      },
      phases: [
        {
          name: "Phase Name",
          list: [], // hourly
          list2: [], // %
          list3: [] // fixed
        }
      ],
      moduleColumns: {
        metaElements: [
          { name: "Description", type: "metaElement" },
          { name: "Attachments", type: "metaElement" },
          { name: "Quantity", type: "metaElement" }
        ],
        fixedElements: [{ name: "Fixed Price", type: "fixedElement" }],
        hourlyElements: [
          // {name: 'Content', type: 'hourlyElement'},
          // {name: 'Designer', type: 'hourlyElement', hourlyRateOverride: 45},
          // {name: 'Developer', type: 'hourlyElement'},
          // {name: 'Sys Admin', type: 'hourlyElement'}
        ],
        percentTasks: [
          // {name: 'Tester', type: 'percentElement'}
        ]
      },
      modules: [
        {
          name: "New Group",
          components: [
            {
              name: "Deliverable 1",
              moduleColumns: {
                metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                hourlyElements: [
                  // {lo: 0, mid: 0, hi: 1},
                  // {lo: 0, mid: 0, hi: 1},
                  // {lo: 0, mid: 2, hi: 3},
                  // {lo: 0, mid: 4, hi: 6}
                ],
                percentTasks: [
                  // {lo: 10, mid: 10, hi: 10}
                ]
              }
            },
            {
              name: "Deliverable 2",
              moduleColumns: {
                metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                hourlyElements: [
                  // {lo: 0, mid: 0, hi: 1},
                  // {lo: 0, mid: 4, hi: 10},
                  // {lo: 0, mid: 8, hi: 12},
                  // {lo: 0, mid: 0, hi: 1}
                ],
                percentTasks: [
                  // {lo: 10, mid: 10, hi: 10}
                ]
              }
            },
            {
              name: "Deliverable 3",
              moduleColumns: {
                metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                hourlyElements: [
                  // {lo: 0, mid: 4, hi: 5},
                  // {lo: 0, mid: 12, hi: 13},
                  // {lo: 0, mid: 0, hi: 1},
                  // {lo: 0, mid: 0, hi: 1}
                ],
                percentTasks: [
                  // {lo: 10, mid: 10, hi: 10}
                ]
              }
            }
          ]
        }
      ]
    };

    if (item.fromTemplate == true) {
      projectDataFull = item.template.projectfull;
    }

    var myProjectsData = {
      [projectKey]: "admin"
    };

    console.log("company tasks", item.companyTasks);
    for (var task in item.companyTasks) {
      if (item.companyTasks[task].useDefaultTask) {
        var taskItem = {};
        item.companyTasks[task].taskImage
          ? (taskItem.taskImage = item.companyTasks[task].taskImage)
          : null;
        item.companyTasks[task].hourlyRateOverride
          ? (taskItem.hourlyRateOverride =
              item.companyTasks[task].hourlyRateOverride)
          : null;
        item.companyTasks[task].hourlyCostOverride
          ? (taskItem.hourlyCostOverride =
              item.companyTasks[task].hourlyCostOverride)
          : null;
        item.companyTasks[task].name
          ? (taskItem.name = item.companyTasks[task].name)
          : null;
        item.companyTasks[task].useDefaultTask
          ? (taskItem.useDefaultTask = item.companyTasks[task].useDefaultTask)
          : null;
        item.companyTasks[task].useTaskCost
          ? (taskItem.useTaskCost = item.companyTasks[task].useTaskCost)
          : null;
        item.companyTasks[task].taskType
          ? (taskItem.type = item.companyTasks[task].taskType)
          : null;
        item.companyTasks[task].useTaskRate
          ? (taskItem.useTaskRate = item.companyTasks[task].useTaskRate)
          : null;
        item.companyTasks[task].taskTypeNew
          ? (taskItem.taskTypeNew = item.companyTasks[task].taskTypeNew)
          : null;
        item.companyTasks[task].taskTypeStart
          ? (taskItem.taskTypeStart = item.companyTasks[task].taskTypeStart)
          : null;

        projectDataFull.moduleColumns[item.companyTasks[task].taskType].push(
          taskItem
        );

        for (var module in projectDataFull.modules) {
          for (var component in projectDataFull.modules[module].components) {
            projectDataFull.modules[module].components[component].moduleColumns[
              item.companyTasks[task].taskType
            ].push({ lo: 0, mid: 0, hi: 0 });
          }
        }
      }
    }

    console.log("New Project", projectDataFull);
    // return false

    var __data = {
      projectKey: projectKey,
      projectData: projectData,
      myid: item.myID,
      myProjectsData: myProjectsData,
      projectDataFull: projectDataFull
    };

    axios
      .post("/addnewproject", {
        params: {
          format: "json",
          data: __data
        }
      })
      .then(function(response) {
        console.log("RESPONSE 11111", response, item.comment);
        state.commit("ADD_PROJECT", { ...projectData, projectID: projectKey });
        state.commit("ADD_PROJECT_FULL", {
          ...projectDataFull,
          projectID: projectKey
        });
        router.push("/projectpricing/" + projectKey);
      })
      .catch(function(error) {
        console.log("ERROR 11111", error.response);
      })
      .then(function() {
        // always executed
      });

    // firebaseInstance.database().ref('projects/' + projectKey).update(projectData, () => {
    //   firebaseInstance.database().ref('users/' + item.myID + '/myProjects').update(myProjectsData, () => {
    //     firebaseInstance.database().ref('projectsFull/' + projectKey).update(projectDataFull, () => {
    //       console.log('saved project')
    //       state.commit('ADD_PROJECT', {...projectData, projectID: projectKey})
    //       state.commit('ADD_PROJECT_FULL', {...projectDataFull, projectID: projectKey})
    //       router.push('/projectpricing/' + projectKey)
    //     }).catch((error) => {
    //       console.log('Error saving full project data', error)
    //     })
    //   }).catch((error) => {
    //     console.log('Error saving project data to user', error)
    //   })
    // }).catch((error) => {
    //   console.log('Error saving project data', error)
    // })
  },
  createNewProjectFromPreset (state, item) {

    console.log('createNewProjectFromPreset action', item)
    var projectKey = ''
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
    for (var i = 32; i > 0; --i) projectKey += chars[Math.floor(Math.random() * chars.length)]
    var date = new Date()
    date = date.getTime()

    // item.type => 'website', 'app', etc.
    // item.preset =>
    // 'custom-project'
    // 'basic-website'
    // 'responsive-website'
    // 'ios-android-app'
    // 'enterprise-mvp'

    var projectData = {
      name: item.name,
      created: date,
      status: "pending",
      type: item.type,
      users: {
        [item.myID]: "admin"
      }
    };

    var projectDataFull;

    // if (item.preset == 'small-website') {
    //   projectDataFull = {
    //     users: {
    //       [item.myID]: 'admin'
    //     },
    //     approach: 'bottom-up',
    //     blendedRate: item.rate || 0,
    //     rate: item.rate || 0,
    //     contingency: item.contingency || 0,
    //     phases: [
    //       {
    //         name: 'Phase Name',
    //         list: [], // hourly
    //         list2: [], // %
    //         list3: [] // fixed
    //       }
    //     ],
    //     moduleColumns:  {
    //                       metaElements:   [
    //                                         {name: 'Description', type: 'metaElement'},
    //                                         {name: 'Attachments', type: 'metaElement'},
    //                                         {name: 'Quantity', type: 'metaElement'}
    //                                       ],
    //                       fixedElements:  [
    //                                         {name: 'Fixed Price', type: 'fixedElement'}
    //                                       ],
    //                       hourlyElements: [
    //                                         {name: 'Designer', type: 'hourlyElement'},
    //                                         {name: 'Developer', type: 'hourlyElement'},
    //                                         {name: 'Writer', type: 'hourlyElement'},
    //                                         // {name: 'Sys Admin', type: 'hourlyElement'}
    //                                       ],
    //                       percentTasks:   [
    //                                         {name: 'Quality Assurance', type: 'percentElement'}
    //                                       ]
    //                     },
    //     modules:  [
    //                 {
    //                   name: 'Pre-Prod',
    //                   components: [
    //                                 {
    //                                   name: 'Discovery',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 8, hi: 1},
    //                                                                       {lo: 0, mid: 8, hi: 1},
    //                                                                       {lo: 0, mid: 2, hi: 3},
    //                                                                       // {lo: 0, mid: 4, hi: 6}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ]
    //                                                   }
    //                                 },
    //                                 {
    //                                   name: 'Concept Designs',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 24, hi: 1},
    //                                                                       {lo: 0, mid: 0, hi: 10},
    //                                                                       {lo: 0, mid: 0, hi: 12},
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ]
    //                                                   }
    //                                 },
    //                                 {
    //                                   name: 'Environment Setup',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 0, hi: 5},
    //                                                                       {lo: 0, mid: 12, hi: 13},
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ]
    //                                                   }
    //                                 }                                  ]
    //                 },
    //                 {
    //                   name: 'Production',
    //                   components: [
    //                                 {
    //                                   name: 'Home Page',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 4, hi: 1}
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}

    //                                                                     ]
    //                                                   }
    //                                 },
    //                                 {
    //                                   name: 'About Page',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 2, hi: 1}
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}

    //                                                                     ]
    //                                                   }
    //                                 },
    //                                 {
    //                                   name: 'Contact Us',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 2, hi: 1}
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}

    //                                                                     ]
    //                                                   }
    //                                 },
    //                                 {
    //                                   name: 'Terms and Conditions',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 2, hi: 1}
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}

    //                                                                     ]
    //                                                   }
    //                                 },
    //                                 {
    //                                   name: 'Analytics',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       {lo: 0, mid: 2, hi: 1}
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}

    //                                                                     ]
    //                                                   }
    //                                 }
    //                               ]
    //                 },
    //                 {
    //                   name: 'Post-Production',
    //                   components: [
    //                                 {
    //                                   name: 'Deployment',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 1, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 0, hi: 4},
    //                                                                       {lo: 0, mid: 4, hi: 6},
    //                                                                       {lo: 0, mid: 0, hi: 1},
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ]
    //                                                   }
    //                                 },
    //                                 {
    //                                   name: 'Post Launch Review',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 0, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 2, hi: 4},
    //                                                                       {lo: 0, mid: 2, hi: 6},
    //                                                                       {lo: 0, mid: 2, hi: 1},
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ]
    //                                                   }
    //                                 },
    //                                 {
    //                                   name: 'Email Blast',
    //                                   moduleColumns:  {
    //                                                     metaElements:   [
    //                                                                       '',
    //                                                                       '',
    //                                                                       {lo: 0, mid: 1, hi: 1}
    //                                                                     ],
    //                                                     fixedElements:  [
    //                                                                       {lo: 0, mid: 45, hi: 0}
    //                                                                     ],
    //                                                     hourlyElements: [
    //                                                                       {lo: 0, mid: 2, hi: 4},
    //                                                                       {lo: 0, mid: 4, hi: 6},
    //                                                                       {lo: 0, mid: 2, hi: 1},
    //                                                                       // {lo: 0, mid: 0, hi: 1}
    //                                                                     ],
    //                                                     percentTasks:   [
    //                                                                       {lo: 0, mid: 0, hi: 0}
    //                                                                     ]
    //                                                   }
    //                                 }
    //                               ]
    //                 }
    //               ]
    //   }
    // } else
    if (item.preset == "basic-website") {
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: item.rate || 0,
        rate: item.rate || 0,
        contingency: item.contingency || 0,
        phases: [
          {
            name: "Phase Name",
            list: [], // hourly
            list2: [], // %
            list3: [] // fixed
          }
        ],
        moduleColumns: {
          metaElements: [
            { name: "Description", type: "metaElement" },
            { name: "Attachments", type: "metaElement" },
            { name: "Quantity", type: "metaElement" }
          ],
          fixedElements: [{ name: "Fixed Price", type: "fixedElement" }],
          hourlyElements: [
            { name: "Designer", type: "hourlyElement" },
            { name: "Developer", type: "hourlyElement" },
            { name: "Writer", type: "hourlyElement" }
            // {name: 'Sys Admin', type: 'hourlyElement'}
          ],
          percentTasks: [{ name: "Quality Assurance", type: "percentElement" }]
        },
        modules: [
          {
            name: "Pre-Prod",
            components: [
              {
                name: "Discovery",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 8, hi: 1 },
                    { lo: 0, mid: 8, hi: 1 },
                    { lo: 0, mid: 2, hi: 3 }
                    // {lo: 0, mid: 4, hi: 6}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              },
              {
                name: "Concept Designs",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 24, hi: 1 },
                    { lo: 0, mid: 0, hi: 10 },
                    { lo: 0, mid: 0, hi: 12 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              },
              {
                name: "Environment Setup",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 0, hi: 5 },
                    { lo: 0, mid: 12, hi: 13 },
                    { lo: 0, mid: 0, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              }
            ]
          },
          {
            name: "Production",
            components: [
              {
                name: "Home Page",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 4, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              },
              {
                name: "About Page",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 2, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              },
              {
                name: "Contact Us",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 2, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              },
              {
                name: "Terms and Conditions",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 2, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              },
              {
                name: "Analytics",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 0, hi: 1 },
                    { lo: 0, mid: 2, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              }
            ]
          },
          {
            name: "Post-Production",
            components: [
              {
                name: "Deployment",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 0, hi: 4 },
                    { lo: 0, mid: 4, hi: 6 },
                    { lo: 0, mid: 0, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              },
              {
                name: "Post Launch Review",
                moduleColumns: {
                  metaElements: ["", "", { lo: 0, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 2, hi: 4 },
                    { lo: 0, mid: 2, hi: 6 },
                    { lo: 0, mid: 2, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              },
              {
                name: "Email Blast",
                moduleColumns: {
                  metaElements: ["", "", { lo: 0, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 45, hi: 0 }],
                  hourlyElements: [
                    { lo: 0, mid: 2, hi: 4 },
                    { lo: 0, mid: 4, hi: 6 },
                    { lo: 0, mid: 2, hi: 1 }
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [{ lo: 0, mid: 0, hi: 0 }]
                }
              }
            ]
          }
        ]
      };
    } else if (item.preset == "software-assurance") {
      // 6
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: "600",
        contingency: "500",
        moduleColumns: {
          fixedElements: [
            {
              name: "Fixed Price",
              type: "fixedElement"
            }
          ],
          hourlyElements: [
            {
              hourlyRateOverride: "20",
              name: "SQA Project Manager",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              name: "New Resource",
              type: "hourlyElement"
            }
          ],
          metaElements: [
            {
              name: "Description",
              type: "metaElement"
            },
            {
              name: "Attachments",
              type: "metaElement"
            },
            {
              name: "Quantity",
              type: "metaElement"
            }
          ]
        },
        modules: [
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "QA Plan"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Develop/Document SQA Plan"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Review tailored SQA Plan for projects’ characteristics"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Approve SQA Plan"
              }
            ],
            name: "Review Software Products"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Evaluate tool as a continuous integration and feedback mechanism (Trac)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Agile project management software helps create product and sprint backlog and tracks velocity?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Digital cameras are used for quickly capturing whiteboard sessions?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Wiki allows stakeholders to create, view, amend and discuss project elements?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Resolve Audit Findings"
              }
            ],
            name: "Evaluate Software Tools"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Issue Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Design is reviewed before implementation phase?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "SRS is reviewed when ready?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Code is reviewed once in a sprint at least?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "DB design and development is reviewed once a sprint at least?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Are issues raised, assessed and resolved in a timely and efficient manner?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Unit testing is done before submitting module for testing?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Functional testing bug report is reviewed once in a sprint at least?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Informal demo is given before release that shows tested working software?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Is user involvement adequate?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "does a documented process exist for effective integration between / among methods?"
              }
            ],
            name: "Evaluate Software Products Review Process"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Project Planning, Tracking & Oversight (PPT&O) Process"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Daily scrum is conducted?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Current sprint progress can be seen any time?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Team acts when behind schedule?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Develop SDP/PMP and other project plans (Gantt Chart, WBS, Resource Usage)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Has a structured approach been used to break work effort into manageable components?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Are team members involved in the development of activity & task decomposition?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Teams are given choice to choose among Product Backlog items to work on?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Sprint planning meeting is conducted between Scrum Master (SM) and PO and then SM and team?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Are individual tasks of reasonable duration (8–40 hrs.)?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Current scope of the project is substantially different than that originally defined in the approved project plan?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Is there a project organization chart showing the reporting relationships and responsibilities for each position?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Has allowance been made for vacations, holidays, training (learning time for each team member), staff promotions & staff turnovers?"
              }
            ],
            name: "Evaluate Project Planning, Tracking and Oversight Processes"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "System Requirements Analysis Process"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Develop/document System Requirements"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Review System Requirements"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Approve System Requirements"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "New requirement comes through story points by Product Owner"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Review / Document changes in requirements"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Evaluate/report System Requirements Analysis Process"
              }
            ],
            name: "Evaluate System Requirements Analysis Process"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "System Design Process"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Develop/document System Design"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Review System Design"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Are object-based design principles being employed?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Are application interfaces designed in such a way as to facilitate maintenance and change?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Is an active data dictionary in place?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Has the data model been integrated with the other user and system views of the data?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Resolve Audit Findings"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Approve System Design"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "   \t\t  Evaluate/report System Design Process"
              }
            ],
            name: "Evaluate Software Design Process"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Software Implementation & Unit Testing Process"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "SRS followed while development"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Develop/fix code"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Code review"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Unit test"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Evaluate/report SW Implementation and Unit Testing Process"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Component Testing"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "DB Jobs"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 80
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "User Acceptance Testing"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Fix errors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Regression Testing"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Resolve Audit Findings"
              }
            ],
            name:
              "Evaluate Software Implementation, Unit and Component Testing Process"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Unit Integration and Testing Process"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Iterations doomed to fail are terminated early?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Having fun while working, energy levels are high?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Having fun while working, energy levels are high?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Overtime is rare and happens voluntarily?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Integrate SW"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Test Integrated SW"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Maintain the collection and classification of defects found during/from software assurance and programmatic/project formal and informal reviews"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Approve version release"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Evaluate/report End-item Deliveryg"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Resolve Audit Findings"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Track use of software"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "New requirement is catered by assigning more resources or time?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Code has proper authentication?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Release backlog is updated?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Retrospective scrum is conducted?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Process is continuously improving?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Release is potentially shippable product?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Release items capture product backlog requirements?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Impediment List is maintained and discussed?"
              }
            ],
            name: "Evaluate System Qualification Testing Processes"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Present the status and quality of the software at formal reviews"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "If not, have all project delays been adequately accounted for?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Are corrective actions taken when actual results are substantially different from detailed project plan?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Corrective Action Process is followed?"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Evaluate/report Corrective Action Process"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Resolve Audit Findings"
              }
            ],
            name: "Evaluate the Corrective Action Process"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Document deviations & waivers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Recommend Approval"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Evaluate/report Deviation & Waiver Process"
              }
            ],
            name: "Evaluate Deviations and Waivers"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Initial Phase:"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Project Plan (including WBS)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "PMP provides a list of the references that were used in preparation of this document."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Design Phase:"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Functional Requirements and Database Specifications are documented"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 80
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Validation, Verification, and Testing Plan (initial)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Evaluation Phase:"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Test Results and Evaluation Reports"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Operation Phase:"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Document, track, and resolve problems found with the implementation of software life cycle processes"
              }
            ],
            name: "Evaluate Configuration Management Process"
          }
        ],
        phases: [
          {
            name: "Phase Name"
          }
        ],
        rate: "600"
      };
    } else if (item.preset == "conference-event") {
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: "0",
        contingency: "0",
        dontNull: true,
        moduleColumns: {
          fixedElements: [
            {
              name: "Fixed Price",
              type: "fixedElement"
            }
          ],
          metaElements: [
            {
              hidden: true,
              name: "Description",
              type: "metaElement"
            },
            {
              hidden: true,
              name: "Attachments",
              type: "metaElement"
            },
            {
              hidden: true,
              name: "Quantity",
              type: "metaElement"
            }
          ]
        },
        modules: [
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Browser"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "iOS"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Android"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Branding - Design/Wireframes/Setup"
              }
            ],
            name: "Base Setups"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1000
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Standard Sessions (Webinars, etc) - Base 10 Sessions"
              }
            ],
            name: "Base Sessions"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3000
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Account Manager (weeks)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1500
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Event Operations Support (1 day)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3000
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Post-Event Reports (Tracking and Analytics)"
              }
            ],
            name: "Client Onboarding, Training, and Support"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 4
                    }
                  ]
                },
                name: "5 Small"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1875
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 2
                    }
                  ]
                },
                name: "3 Regular"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "1 Premium"
              }
            ],
            name: "Base Booth Setups"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "In App Stories +"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Varied TR marketing opportunities"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Varied D365 marketing opportunities"
              }
            ],
            name: "Marketing "
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Small Booth (1 month ops)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1875
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Regular Booth (1 month ops)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Premium Booth (1 month ops)"
              }
            ],
            name: "Sponsorship / Booth Setups"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 125
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "+1 Standard Sessions (Webinars, etc)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 125
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "'Support with Session Setup (per Session)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "+1 Premium Session (LiveStreams, Workshops)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 750
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Electronic Voting "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1000
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Posters (Base 20 Poster)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 75
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "+1 Poster"
              }
            ],
            name: "Add-Ons"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 85
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Post/Share Files for Participant View"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 85
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Chat Capability"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 85
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "French/English Toggle"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 85
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Booths - Group integration into VCON App"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 85
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Virtual Info Area - Listings, Chat, Video"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 85
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Private Chat in Booths"
              }
            ],
            name: "New Features"
          }
        ],
        phases: [
          {
            name: "Phase Name"
          }
        ],
        rate: "600"
      }; // didn't find
    } else if (item.preset == "small-website-wordpress") {
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: 600,
        rate: 600,
        contingency: 500,
        moduleColumns: {
          fixedElements: [
            {
              name: "Fixed Price",
              type: "fixedElement"
            }
          ],
          hourlyElements: [
            {
              hourlyRateOverride: "20",
              name: "Project Manager",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "15",
              name: "BackEnd Developer",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "10",
              name: "UX/UI Developer (front-end)",
              type: "hourlyElement",
              useTaskRate: true
            }
          ],
          metaElements: [
            {
              name: "Description",
              type: "metaElement"
            },
            {
              name: "Attachments",
              type: "metaElement"
            },
            {
              name: "Quantity",
              type: "metaElement"
            }
          ]
        },
        modules: [
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Technical and functional conception"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 120
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 6
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Requirements Elicitation"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 120
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 6
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Software Requiements Specification"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Wordpress Installation "
              }
            ],
            name: "Project Inititation"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 6
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Installation of Purchased Theme"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Check Responsiveness "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Acceptance Testing"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Functional Modules"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "UI Settings of Home Page"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "UI Settings Services Page"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "I Settings About Page"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "UI Settings Terms & Conditions"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "UI Settings FAQ"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "UI Settings Contact Us"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "UI Settings Terms & Conditions"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "UI Settings Privacy Policy"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 75
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Admin Panel"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "User Acceptance Testing"
              }
            ],
            name: "Production"
          }
        ],
        phases: [
          {
            name: "Phase Name"
          }
        ]
      }; // 1
    } else if (item.preset == "medium-webapp") {
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: "600",
        contingency: "500",
        moduleColumns: {
          fixedElements: [
            {
              name: "Fixed Price",
              type: "fixedElement"
            }
          ],
          hourlyElements: [
            {
              hourlyRateOverride: "20",
              name: "Project Manager",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "10",
              name: "UX/UI Developer (front-end)",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "15",
              name: "Developer Back-end",
              type: "hourlyElement",
              useTaskRate: true
            }
          ],
          metaElements: [
            {
              name: "Description",
              type: "metaElement"
            },
            {
              name: "Attachments",
              type: "metaElement"
            },
            {
              name: "Quantity",
              type: "metaElement"
            }
          ],
          percentTasks: [
            {
              hourlyRateOverride: "10",
              name: "Quality assurance Engineer",
              taskPercentOverride: "10",
              type: "hourlyElement"
            }
          ]
        },
        modules: [
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Technical and functional conception"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Work Break Down Structure (WBS)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Concept Designs/Wireframes"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Environment Setup"
              }
            ],
            name: "Planning & System Analysis Phase"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Design Layouts"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Conversion to Html"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Responsiveness "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 50
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Acceptance Testing"
              }
            ],
            name: "Design Phase"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "JOB POSTING"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "New job Posting"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Job Posting Detailed form containing categories, location, salary, experience etc"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Select plan for validity of Job posting"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Payments according to the price of plan."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Email Notification after job is posted"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Show summary of job to be posted with button to launch the job"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Posted Jobs"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Enlist all the posted jobs from specific account"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Options to Search, Edit, Deactivate or repost any Job from the posted list"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Option to make a job featured on top with additional cost."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Share job on social media like facebook, twitter etc"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Show CVs received against each job posted. Count on main list of jobs"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Show all CVs received so far once clicked on any posted job."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Option to View , Print or download any CV"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Option to Print or download list of all received CVs against specific Job posted"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Option to Extend the job posted by adding more credit payments"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Detailed View of CV"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Option to contact the person"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Show Credits available for posting jobs"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 75
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Filtered Search options"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "JOB APPLYING"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "CV Creation Wizard"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "CV creation wizard forms having all the details needed"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "View Completed CV with option to downlaod, print , delete, make default"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Option to be able to create more than 1 Cv and make one default"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Job Applying"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "List of all Jobs posted"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Search filter criteria based on differrent parameters"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Detailed View page to show Job details"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Option to apply for the job If criteria set by Employer meets."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Payment to apply for a job"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Email Notification after applying for job"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Applied Job"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "List of all the Applied jobs with their respective status"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Option for search by parameters"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Option to cancel the applied job"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Option to share the Job on Social Media"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Option to Save a Job so that later it can be applied"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Graph Showing the number of Jobs applied each month."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Option to set the Job Alerts according to parameters like category and location"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Show Credits available for applying jobs"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Job alerts in email notifications, Set by user"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "ADMIN PANEL FEATURES"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Admin Dashboard"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Option to set the Predefined Jobs categories"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Option to set predefined payment rates for job posting and job applying"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Jobs"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "List of all Jobs posted with search criteria"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Option to Delete/ Activate/ Deactivate any job"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Reports"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Jobs Posted in Specific Time period (DateWise)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Jobs Applied in Specific Time period (DateWise)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Paymemts received through job posting in specific time period (Date Filter Criteria)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name:
                  "Paymemts received through job applying in specific time period (Date Filter Criteria)"
              }
            ],
            name: "Development Phase"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Deployment in staging environment/UAT"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 50
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Test on Staging"
              }
            ],
            name: "Quality Assurance Phase"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Deployment in production environment/"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ],
                  percentTasks: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ]
                },
                name: "Live Review"
              }
            ],
            name: "Deployment & Sign off"
          }
        ],
        phases: [
          {
            name: "Phase Name"
          }
        ],
        rate: "600"
      }; // 2
    } else if (item.preset == "large-webapp") {
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: "600",
        contingency: "500",
        moduleColumns: {
          fixedElements: [
            {
              name: "Fixed Price",
              type: "fixedElement"
            }
          ],
          hourlyElements: [
            {
              hourlyRateOverride: "20",
              name: "Project Manager",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "10",
              name: "UI Developer",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "15",
              name: "Back end Developer",
              type: "hourlyElement",
              useTaskRate: true
            }
          ],
          metaElements: [
            {
              name: "Description",
              type: "metaElement"
            },
            {
              name: "Attachments",
              type: "metaElement"
            },
            {
              name: "Quantity",
              type: "metaElement"
            }
          ]
        },
        modules: [
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Interviewing with stakeholders"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 400
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Technical and functional conception"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 300
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Work Break Down Structure (WBS)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 500
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 25
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Software Requirements specification (SRS)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 300
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Concept Designs/Wireframes"
              }
            ],
            name: "Planning & System Analysis Phase"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Design Layouts"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Conversion to Html"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Responsiveness"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 50
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Acceptance Testing"
              }
            ],
            name: "Design Phase"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "FRONT END WEBSITE"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Main Landing page/Home page"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Services We Provide"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "About us"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Our Vision / Our Mission"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Our Team / Trainers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Contact us"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Careers/ Why you should join us"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Space to show advertisements managed by admin"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Testimonials"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Register for LMS (Depends on clients requirement)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Login/Forgot password"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Integration of online help chat/ Facebook help chat"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Social network links (Facebook/twitter/linkedin/pintrest/instagram/gmail"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "APPLICATION PORTION"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "System User management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add system Users"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Edit/Activate/Deactivate/Delete Users"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Define Roles (Admin/Subadmin)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Assign roles to Users"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage CMS Pages (Add/Edit/Delete/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Show all CVs received so far once clicked on any posted job."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Services Page (Add/Edit/Delete/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage about us Page (Add/Edit/Delete/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Events Page (Add/Edit/Delete/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Team Page (Add/Edit/Delete/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage social media links (Add/Edit/Delete/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Courses (Add/Edit/Delete/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Advertisement (Add/Edit/Delete/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Enrolled Users"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Enroll new Portal user"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "edit/Deactivate/Activate/Delete Enrolled users"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Reset Passwords"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Registered Users"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Register new portal user who can access only library"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "edit/Deactivate/Activate/Delete Registered users"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Reset Passwords"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "STUDENT PORTAL (ENROLLED)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Profile"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Complete the remaining information left for profile"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Edit profile information/ Profile settings"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Change Password"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Signout"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Online Library"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Catalog with types of document like books, manuals, magazines, past papers, notes etc"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Search criteria for finding any type of document. (Search by name, search by author, search by course etc )"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Mark/Unmark any document as important for future reference"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "List of documents marked important"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "List of online videos with search criteria (search by Title of video, date of upload, search by Category)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Video Recorded lecture"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "List of videos with pagination with search criteria (search by Title of video, date of upload, search by course)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Watch videos online on portal"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "If attendance is below 75 perc access to videos will be blocked"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "List of important contacts necessary for students"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Schedule will be shown to students for upcoming classes in respective time of specific week."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "List of important announcements will be shown to students with a detail note on next page."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Quiz for students that can be given any time"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Result shown at the completion of quiz"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Detail and course headlines of the opted courses visible to student."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Students should be able to login to their portal"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "reset password if forgot"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "View Attendance"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Should be able to view their attendance course wise"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Show alert of low attendance"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Student should be able to view the marks obtained in tests for respective Course."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Search Engine connected with University of Washington Library"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "STUDENT PORTAL (REGISTERED ONLY)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Profile"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Complete the remaining information left for profile"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Edit profile information/ Profile settings"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Change Password"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Signout"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Online Library"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Catalog with types of document like books, manuals, magazines, past papers, notes etc"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Search criteria for finding any type of document. (Search by name, search by author, search by course etc )"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Mark/Unmark any document as important for future reference"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "List of documents marked important"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "List of online videos with search criteria (search by Title of video, date of upload, search by Category)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "List of important contacts necessary for students"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "List of important announcements will be shown to students with a detail note on next page."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Search Engine connected with University of Washington Library"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "TUTORS PORTAL"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Tutors would be able to login to their respective portals"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "reset password if forgot"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Tutors Portal"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Tutors Dashboard"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View list of Courses Assigned currently"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Option to make Quiz for the Students"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage course details visible to students"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Option to take attendance of students enrolled in respective course which tutor is teaching. (in every class)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Tutor would not have option to change the attendance record of student. Only admin can"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Interface to upload the test details along with their marks and grade that will be shown on the students portal."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "BACKEND FOR STUDENT PORTAL"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "anage Online Library"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Categories for library (Add/Edit/Delete )"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Documents (Add/remove/deactivate/Activate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage video recorded lectures"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Categories for Videos (Add/Edit/Delete )"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Videos (Add/remove/deactivate/Activate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage CMS page for contacts (Add/Edit/Remove)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Lecture Schedule"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage lecture Schdule for respective students"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Courses"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Courses (Add/Edit/Remove/Activate/Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage content of courses"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage CMS page for Noticeboard (Add/Edit/Remove)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Quiz"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 75
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Quizes for respective coursewise"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Create quiz for course / multiple choice options/ also have to feed the anwers / Quiz setting sectio"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Course Assigned"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage the courses assigned to respective students."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Should be able to unassign aswell"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Reports"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Total number of Students enrolled (Monthwise,quarter wise, yearly)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Total number of Students enrolled in each course"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Total number documents in library(Categorywise)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Grade Sheet of Students"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Interface to upload the test details along with their marks and grade that will be shown on the students portal."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Able to Edit the grades."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Attendance of Students"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "View the attendance of students with filters (Course wise, Each student wise, with date range)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 30
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Can edit the already marked attendance on request of tutor or any other justified case."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Show alerts with names of students having low attendance."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "BACKEND FOR TUTORS PORTAL"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Tutors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage tutors (Register,Edit,delete,Deactivate)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Change Password"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Courses Assigned to tutors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Courses assigned to Tutors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Should be able to unassign aswell"
              }
            ],
            name: "Development Phase"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 75
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Deployment in staging environment/UAT"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 500
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Test on Staging"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Acceptance Criteria"
              }
            ],
            name: "Quality Assurance Phase"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Deployment in production environment/"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Live Review"
              }
            ],
            name: "Deployment & Sign off"
          }
        ],
        phases: [
          {
            name: "Phase Name"
          }
        ],
        rate: "600"
      }; // 3
    } else if (item.preset == "medium-desktop-app") {
      // 4
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: "600",
        contingency: "500",
        moduleColumns: {
          fixedElements: [
            {
              name: "Fixed Price",
              type: "fixedElement"
            }
          ],
          hourlyElements: [
            {
              hourlyRateOverride: "20",
              name: "Project Manager",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "10",
              name: "UI Developer",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "20",
              name: "Back End Developer",
              type: "hourlyElement",
              useTaskRate: true
            }
          ],
          metaElements: [
            {
              name: "Description",
              type: "metaElement"
            },
            {
              name: "Attachments",
              type: "metaElement"
            },
            {
              name: "Quantity",
              type: "metaElement"
            }
          ]
        },
        modules: [
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Technical and functional conception"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Work Break Down Structure (WBS)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Environment Setup"
              }
            ],
            name: "System Analysis & Setup"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Graphic Designing for Screens"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Wireframing"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 450
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 45
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Grahics designing of controls"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 80
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 8
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Grahic designing of screens"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Graphic Designing of Splash Screen"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Concept Design"
              }
            ],
            name: "Design Phase of Desktop Application"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Control Panel"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "User Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Personal Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Personal Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Personal Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Company Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Company Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Company Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Company Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Company regional Office"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Company regional Office"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Company regional Office"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Company Shops"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Company Shops"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Company Shops"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Currency Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Currency"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Currency"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Currency settings"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Define Currency rate"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Currency rate settings"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Inventory Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Item Group Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Item Group "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Item Group"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Item Group."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Item Cetegory "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Item Category"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Item Category"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Item Groups"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Item Categories"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Item Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Items Complete information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Edit/delete Information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Unit Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Item Units "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Item Units"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Usage detail of each item"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update usage of each item"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Items Location Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Items Location View"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Inventoty on hand"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Inventory on hand"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Set Sale Price of each item"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Sale Price of each item"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Purchase price of each item"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update price of each item"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Purchase order history"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Sales order history"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Stock transfer report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Item Movement (Inward)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Item Movement (Outward)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Item Movement datewise"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Item Movement report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Stock transfer record"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Stock transfer from one place to another"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View current stock with details"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Adjusted Stock"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Stock adjustment"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Supplier Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Suppliers & Distributors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Supplier information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Supplier information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Supplier information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Supplier information"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Distributors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Distributors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Distributors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Distributors"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Supplier details"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Currency details"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Set Opening Balance"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Opening Balance"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Order History"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Payment History"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Supplier Products"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Supplier Products"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Credit Purchase History"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Cash Purchases"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Consolidated Report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Supplier Purchase Orders"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Suppliers Purchase Order details"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Customer Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Customers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Add Customers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Update Customers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Delete Cutomers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Customers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Manage Customers Details"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Currency details"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Set Opening Balance"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Opening Balance"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Order History"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Payment History"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Customer Purchases"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Credit Sales History"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Cash Sales"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Consolidated Report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "View Customers Sales Order"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Customer Sales Order details"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Puchase Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Purchase form"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Purchase list view"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Purchase Search"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Purchase Report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Sales  Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Sales form"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Sales list view"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Sales search "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Item Sales report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Finance Reports"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Cash inflow Report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Balance Sheet Report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 80
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Sales Report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 80
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 4
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Purchase Report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Consolidated Report"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Dashboard "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display Total Sales of day"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display Total Sales of month"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display Total Purchaes of day"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display Most selling item"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display most Purchased item"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display Item reorder list"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display total number of Suppliers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display total number of Customers"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display total number of Items"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Display cash received on current date"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Quality Assurance Phase"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Deployment in staging environment/UAT"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Test on Staging"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Deployment & Sign off"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Deployment in production environment/"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Live Review"
              }
            ],
            name: "Development of Desktop Application"
          }
        ],
        phases: [
          {
            name: "Phase Name"
          }
        ],
        rate: "600"
      };
    } else if (item.preset == "small-mobile-app") {
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: "600",
        contingency: "500",
        moduleColumns: {
          fixedElements: [
            {
              name: "Fixed Price",
              type: "fixedElement"
            }
          ],
          hourlyElements: [
            {
              hourlyRateOverride: "20",
              name: "Project Manager",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "10",
              name: "UI/UX Developer",
              type: "hourlyElement",
              useTaskRate: true
            },
            {
              hourlyRateOverride: "20",
              name: "Back end Developer",
              type: "hourlyElement",
              useTaskRate: true
            }
          ],
          metaElements: [
            {
              name: "Description",
              type: "metaElement"
            },
            {
              name: "Attachments",
              type: "metaElement"
            },
            {
              name: "Quantity",
              type: "metaElement"
            }
          ]
        },
        modules: [
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 120
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 6
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Technical and functional conception"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 200
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 10
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Work Break Down Structure (WBS)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 160
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 8
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Concept Designs/Wireframes"
              }
            ],
            name: "Pre Production"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Front end Designing"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 150
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 15
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Design Layouts "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Acceptance Testing of design."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Functional Modules"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Main Landing Screen/Home screen of app"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Screen showing course categories for students"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Option to recover Password if forgotten "
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Screen showing option for students to login their Portal"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Screen showing option for Tutors to register themselves"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Detail of Tutor to be displayed on a seperate page stating academics, Experience, Details etc"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Courses page after clicking specific course category"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "List of tutors to be displayed after clicking on a course"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name:
                  "Complete detail will be displayed after signing in to the app."
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 0
                    }
                  ]
                },
                name: "Admin Panel"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "User Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Roles Management"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Enrolled student"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 60
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 3
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Tutor"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 100
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 5
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Courses"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 1
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Course Categories"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 40
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 2
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Manage Course Teachings"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 400
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 20
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Web Services for data fetching"
              }
            ],
            name: "Production"
          },
          {
            components: [
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Integration of Code files"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Quality Assurance & testing (local servers)"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Deployment on Google Play Store"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Deliverable"
              },
              {
                moduleColumns: {
                  fixedElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  hourlyElements: [
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    },
                    {
                      hi: 0,
                      lo: 0,
                      mid: 0
                    }
                  ],
                  metaElements: [
                    "",
                    "",
                    {
                      hi: 1,
                      lo: 1,
                      mid: 1
                    }
                  ]
                },
                name: "Launching of App"
              }
            ],
            name: "Post Production"
          }
        ],
        phases: [
          {
            name: "Phase Name"
          }
        ],
        rate: "600"
      }; // 5
    } else {
      projectDataFull = {
        users: {
          [item.myID]: "admin"
        },
        approach: "bottom-up",
        blendedRate: item.rate || 0,
        rate: item.rate || 0,
        contingency: item.contingency || 0,
        phases: [
          {
            name: "Phase Name",
            list: [], // hourly
            list2: [], // %
            list3: [] // fixed
          }
        ],
        moduleColumns: {
          metaElements: [
            { name: "Description", type: "metaElement" },
            { name: "Attachments", type: "metaElement" },
            { name: "Quantity", type: "metaElement" }
          ],
          fixedElements: [{ name: "Fixed Price", type: "fixedElement" }],
          hourlyElements: [
            // {name: 'Content', type: 'hourlyElement'},
            // {name: 'Designer', type: 'hourlyElement', hourlyRateOverride: 45},
            // {name: 'Developer', type: 'hourlyElement'},
            // {name: 'Sys Admin', type: 'hourlyElement'}
          ],
          percentTasks: [
            // {name: 'Tester', type: 'percentElement'}
          ]
        },
        modules: [
          {
            name: "Website",
            components: [
              {
                name: "Server Setup",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 2, hi: 3},
                    // {lo: 0, mid: 4, hi: 6}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              },
              {
                name: "Theme Setup",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 4, hi: 10},
                    // {lo: 0, mid: 8, hi: 12},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              },
              {
                name: "Home Page",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 4, hi: 5},
                    // {lo: 0, mid: 12, hi: 13},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              },
              {
                name: "About Us",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 4, hi: 5},
                    // {lo: 0, mid: 4, hi: 5},
                    // {lo: 0, mid: 2, hi: 3},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              },
              {
                name: "Contact Us",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 2, hi: 4},
                    // {lo: 0, mid: 4, hi: 5},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0/, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 0, mid: 10, hi: 12}
                  ]
                }
              },
              {
                name: "Newsletter Group",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 0.5, hi: 1},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 4, hi: 5},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 0, mid: 10, hi: 12}
                  ]
                }
              }
            ]
          },
          {
            name: "Email",
            components: [
              {
                name: "Mailchimp Setup",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 4, hi: 1},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              },
              {
                name: "Create Email",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 4, hi: 15},
                    // {lo: 0, mid: 8, hi: 12},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              },
              {
                name: "Deploy Email",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 2, hi: 3},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              }
            ]
          },
          {
            name: "Event Promotion",
            components: [
              {
                name: "Flyer Design",
                moduleColumns: {
                  metaElements: ["", "", { lo: 1, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 2, hi: 4},
                    // {lo: 0, mid: 4, hi: 6},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              },
              {
                name: "Printing",
                moduleColumns: {
                  metaElements: ["", "", { lo: 0, mid: 1, hi: 1 }],
                  fixedElements: [{ lo: 0, mid: 0, hi: 0 }],
                  hourlyElements: [
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1},
                    // {lo: 0, mid: 0, hi: 1}
                  ],
                  percentTasks: [
                    // {lo: 10, mid: 10, hi: 10}
                  ]
                }
              }
            ]
          }
        ]
      };
    }

    if (item.fromTemplate == true) {
      projectDataFull = item.template.projectfull;
    }

    var myProjectsData = {
      [projectKey]: "admin"
    };

    // console.log('company tasks', item.companyTasks)
    for (var task in item.companyTasks) {
      if (item.companyTasks[task].useDefaultTask) {
        var taskItem = {};
        item.companyTasks[task].taskImage
          ? (taskItem.taskImage = item.companyTasks[task].taskImage)
          : null;
        item.companyTasks[task].hourlyRateOverride
          ? (taskItem.hourlyRateOverride =
              item.companyTasks[task].hourlyRateOverride)
          : null;
        item.companyTasks[task].hourlyCostOverride
          ? (taskItem.hourlyCostOverride =
              item.companyTasks[task].hourlyCostOverride)
          : null;
        item.companyTasks[task].name
          ? (taskItem.name = item.companyTasks[task].name)
          : null;
        item.companyTasks[task].useDefaultTask
          ? (taskItem.useDefaultTask = item.companyTasks[task].useDefaultTask)
          : null;
        item.companyTasks[task].useTaskCost
          ? (taskItem.useTaskCost = item.companyTasks[task].useTaskCost)
          : null;
        item.companyTasks[task].taskType
          ? (taskItem.type = item.companyTasks[task].taskType)
          : null;
        item.companyTasks[task].useTaskRate
          ? (taskItem.useTaskRate = item.companyTasks[task].useTaskRate)
          : null;
        item.companyTasks[task].taskTypeNew
          ? (taskItem.taskTypeNew = item.companyTasks[task].taskTypeNew)
          : null;
        item.companyTasks[task].taskTypeStart
          ? (taskItem.taskTypeStart = item.companyTasks[task].taskTypeStart)
          : null;

        projectDataFull.moduleColumns[item.companyTasks[task].taskType].push(
          taskItem
        );

        for (var module in projectDataFull.modules) {
          for (var component in projectDataFull.modules[module].components) {
            projectDataFull.modules[module].components[component].moduleColumns[
              item.companyTasks[task].taskType
            ].push({ lo: 0, mid: 0, hi: 0 });
          }
        }
      }
    }

    // console.log('New Project', projectDataFull)
    // return false

    var __data = {
      projectKey: projectKey,
      projectData: projectData,
      myid: item.myID,
      myProjectsData: myProjectsData,
      projectDataFull: projectDataFull
    };

    axios
      .post("/addnewproject", {
        params: {
          format: "json",
          data: __data
        }
      })
      .then(function(response) {
        console.log("RESPONSE 11111", response, item.comment);
        state.commit("ADD_PROJECT", { ...projectData, projectID: projectKey });
        state.commit("ADD_PROJECT_FULL", {
          ...projectDataFull,
          projectID: projectKey
        });
        router.push("/projectpricing/" + projectKey);
      })
      .catch(function(error) {
        console.log("ERROR 11111", error.response);
      })
      .then(function() {
        // always executed
      });

    // firebaseInstance.database().ref('projects/' + projectKey).update(projectData, () => {
    //   firebaseInstance.database().ref('users/' + item.myID + '/myProjects').update(myProjectsData, () => {
    //     firebaseInstance.database().ref('projectsFull/' + projectKey).update(projectDataFull, () => {
    //       // console.log('saved project')
    //       state.commit('ADD_PROJECT', {...projectData, projectID: projectKey})
    //       state.commit('ADD_PROJECT_FULL', {...projectDataFull, projectID: projectKey})
    //       router.push('/projectpricing/' + projectKey)
    //     }).catch((error) => {
    //       // console.log('Error saving full project data', error)
    //     })
    //   }).catch((error) => {
    //     // console.log('Error saving project data to user', error)
    //   })
    // }).catch((error) => {
    //   // console.log('Error saving project data', error)
    // })
  }
};
